<input class="select-option form-control" [(ngModel)]="motivoDescricao" (ngModelChange)="onChangeMotivoDescricao($event)" [ngClass]="{'focus':isShowMotivos}" placeholder="Digite ou selecione o motivo" type="text" (click)="hideMotivos()">
<span class="chevron fa fa-chevron-down" aria-hidden="true" (click)="showHideMotivos()"></span>

<ul class="lista-motivos" *ngIf="isShowMotivos">
    <li class="item-motivo" *ngFor="let motivo of motivosSelecionar">
        <a (click)="selectMotivo(motivo)">{{motivo.descricao}}</a>
    </li>
</ul>